// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__NTlRl","search":"Settings_search__1KqjC","filter":"Settings_filter__3CIZq"};